module.exports = __webpack_public_path__ + "img/cnbc.69a73fe.png";